import {BenchlingAction} from 'redux-stores/Action';

import {MetadataTabActionType} from './MetadataTabReduxActions';

export interface MetadataTabState {
  reviewBlockedByErrors: boolean;
}

export interface MetadataTabsState {
  [fileId: string]: MetadataTabState;
}

export const METADATA_TABS_INITIAL_STATE: MetadataTabsState = {};

export default function reduceMetadataTab(
  state: MetadataTabsState = METADATA_TABS_INITIAL_STATE,
  action: BenchlingAction
): MetadataTabsState {
  switch (action.type) {
    case MetadataTabActionType.SET_REVIEW_BLOCKED_BY_ERRORS:
      return {
        ...state,
        [action.fileId]: {reviewBlockedByErrors: action.reviewBlockedByErrors},
      };
    default:
      return state;
  }
}
